import { RemoteAddCompany } from "../../../../data/usecases/meter/remote-add-company";
import { AddCompany } from "../../../../domain/usecases";
import { makeApiUrl, makeAxiosHttpClient } from "../../http";

export const makeRemoteAddCompany = (): AddCompany =>
  new RemoteAddCompany(
    makeApiUrl("/companies/add-company"),
    makeAxiosHttpClient()
  );
